import Input from "@components/common/Input";
import SelectHasMoreMultipleInputs from "@components/common/SelectHasMoreMultipleInputs";
import SelectInput from "@components/common/SelectInput";
import { IS_CUSTOMER_ROLE } from "@utils/user_roles";
import { useEffect } from "react";

const FormForCustormer = ({
	id,
	statusId,
	handleStatusChange,
	statusData,
	errors,
	setErrors,
	selectedRoleId,
	lastName,
	setLastName,
	firstName,
	setFirstName,
	email,
	setEmail,
	password,
	setPassword,
	selectedUnitId,
	setSelectedUnitId,
	name,
	setName,
	clientId,
	selectedParentId,
	allBusinessList,
	filteredClients,
	filteredVessels,
	userNotification,
	handleEnableUserChange,
	handleClientsChange,
	handleClearInput,
	handleVesselAccessChange,
	vesselAccess,
	vesselName,
	handleVesselChange,
	loadingClientsBu,
	fetchClientsForBu,
	isCustomer,
	hasMore,
	loader,
	selectedVessels,
	handleSearchSelectChange,
	fetchMoreData,
	fetchVesselsByClients,
	clients,
	setClientId,
	isMobile,
}) => {
	useEffect(() => {
		if (allBusinessList.length === 1) {
			setSelectedUnitId(allBusinessList[0].id);
			setName(allBusinessList[0].name);
			fetchClientsForBu([allBusinessList[0].id]);
			setClientId(clients[0].id);
			fetchVesselsByClients(clientId);
		}
	}, [selectedRoleId]);

	return (
		<div className="w-full rounded-lg border border-gray-700 bg-navbar-bg p-6 text-start shadow">
			<form className="space-y-6">
				<span className="font-semibold text-normal text-white">Informations</span>
				{!selectedRoleId && (
					<div className="w-full rounded-lg border border-blue-gray bg-navbar-bg p-4 text-start shadow">
						<span className="font-semibold text-normal text-yellow-500">
							Please select a role first:
						</span>
						<p className="text-gray-300">
							To avoid losing any entered data, make sure to select a role before filling out the
							other fields.
						</p>
					</div>
				)}
				{/* Status Field */}
				<div>
					<label className="items-center font-medium text-gray-400 text-sm">
						Status<span className="ml-1 text-gray-400">*</span>
					</label>
					<SelectInput
						id="status"
						dataTestId="status-select"
						placeholder="Status"
						// label=""
						value={statusId}
						onChange={handleStatusChange}
						options={statusData}
						displayField="status"
						className={`mb-2 block w-full rounded-lg border border-gray-600 bg-gray-700 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
							errors?.statusId ? "border-red-500" : ""
						}`}
						required
						marginTop={`${isMobile ? "mt-2" : "mt-16"}`}
						classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
					/>
					{errors?.statusId && <p className="mt-1 text-red-500 text-sm">{errors.statusId}</p>}
				</div>
				{/* Last name Field */}
				<div>
					<label className="items-center font-medium text-gray-400 text-sm">
						Last name<span className="ml-1 text-gray-400">*</span>
					</label>
					<Input
						id="lastName"
						placeholder="Last name"
						value={lastName}
						onChange={(value) => {
							setLastName(value);
							setErrors((prevErrors) => ({
								...prevErrors,
								lastName: "",
							}));
						}}
						onClear={() => handleClearInput("lastName")}
						className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
							errors?.lastName ? "border-red-500" : ""
						}`}
						required
					/>
					{errors?.lastName && <p className="text-red-500 text-sm">{errors?.lastName}</p>}
				</div>
				{/* First name Field */}
				<div>
					<label className="items-center font-medium text-gray-400 text-sm">
						First name<span className="ml-1 text-gray-400">*</span>
					</label>
					<Input
						id="firstName"
						placeholder="First name"
						value={firstName}
						onChange={(value) => {
							setFirstName(value);
							setErrors((prevErrors) => ({
								...prevErrors,
								firstName: "",
							}));
						}}
						onClear={() => handleClearInput("firstName")}
						className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
							errors?.firstName ? "border-red-500" : ""
						}`}
						required
					/>
					{errors?.firstName && <p className="text-red-500 text-sm">{errors?.firstName}</p>}
				</div>
				{/* Email Field */}
				<div>
					<label className="items-center font-medium text-gray-400 text-sm">
						Email<span className="ml-1 text-gray-400">*</span>
					</label>
					<Input
						id="email"
						placeholder="Email"
						type="email"
						value={email}
						onChange={(value) => {
							setEmail(value);
							setErrors((prevErrors) => ({
								...prevErrors,
								email: "",
							}));
						}}
						onClear={() => handleClearInput("email")}
						className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
							errors?.email ? "border-red-500" : ""
						}`}
						required
					/>
					{errors?.email && <p className="text-red-500 text-sm">{errors?.email}</p>}
				</div>
				{/* Password Field */}
				{!id && (
					<div>
						<label className="items-center font-medium text-gray-400 text-sm">
							Password<span className="ml-1 text-gray-400">*</span>
						</label>
						<Input
							id="password"
							placeholder="Password"
							value={password}
							onChange={(value) => {
								setPassword(value);
								setErrors((prevErrors) => ({
									...prevErrors,
									password: "",
								}));
							}}
							// isDisabled={true} // Conditionally disable the input
							onClear={() => handleClearInput("password")}
							className={`input-bg mb-2 block w-full rounded-lg border border-gray-600 py-3 text-gray-400 text-sm placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
								errors?.password ? "border-red-500" : ""
							}`}
							required
						/>
						{errors?.password && <p className="text-red-500 text-sm">{errors?.password}</p>}
					</div>
				)}

				{/* Business Units Field */}

				{/* Client */}

				{/* {selectedUnitId && (
          // (selectedRoleId === IS_CUSTOMER_ROLE ||
          //   selectedParentId === IS_CUSTOMER_ROLE) &&

          <>
            {loadingClientsBu ? (
              <div className="mt-2">
                <Skeleton
                  height={16}
                  borderRadius={6}
                  baseColor="#727DA3"
                  highlightColor="#1b204c"
                />
              </div>
            ) : filteredClients.length > 0 ? (
              <>
                <SelectInput
                  id="clientSelect"
                  placeholder="Select a Client"
                  label=" Clients *"
                  value={clients[0].id}
                  onChange={handleClientsChange}
                  options={filteredClients}
                  displayField="name"
                  className={`block w-full py-3 text-sm border rounded-lg bg-gray-700 border-gray-600 placeholder-gray-400 text-gray-400 focus:ring-primary-500 focus:border-primary-500 ${
                    errors.clientId ? "border-red-500" : ""
                  }`}
                  required
                />
                {errors.clientId && (
                  <p className="text-red-500 text-sm">{errors.clientId}</p>
                )}
              </>
            ) : null}
          </>
        )} */}
				{/* Vessel Access Field */}
				{(selectedRoleId === IS_CUSTOMER_ROLE || selectedParentId === IS_CUSTOMER_ROLE) && (
					<>
						{clients[0].id && filteredClients.length > 0 && selectedUnitId && (
							<>
								<div className="flex items-center">
									<input
										id="link-checkbox-vess-access"
										type="checkbox"
										checked={vesselAccess}
										onChange={handleVesselAccessChange}
										className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
									/>
									<label htmlFor="link-checkbox-vess-access" className="ms-2 text-gray-400">
										Enable Vessel Access
									</label>
								</div>

								{/* Vessel Field */}
								{vesselAccess && clients[0] && (
									<>
										<SelectHasMoreMultipleInputs
											id="siteName"
											placeholder="Select one or more site name"
											label="Site Name *"
											value={vesselName}
											onChange={handleVesselChange}
											options={filteredVessels.map((vessel) => ({
												id: vessel.id,
												name: vessel.site_name,
											}))}
											displayField="name"
											fetchMoreData={() => fetchMoreData()}
											hasMore={hasMore}
											loader={loader}
											selectedItems={selectedVessels}
											search={handleSearchSelectChange}
											marginTop={`${isMobile ? "mt-2" : "mt-20"}`}
											classDropdown={`${isMobile ? "relative  " : "absolute z-50"}`}
										/>
										{errors.vesselName && (
											<p className="text-red-500 text-sm">{errors.vesselName}</p>
										)}
									</>
								)}
							</>
						)}
					</>
				)}

				{/* User Notification Field */}
				<div className="flex items-center">
					<input
						id="link-checkbox-notification"
						type="checkbox"
						checked={userNotification}
						onChange={handleEnableUserChange}
						className="h-4 w-4 rounded border-blue-gray bg-blue-gray text-blue-gray ring-offset-dark-blue focus:ring-2 focus:ring-dark-blue"
					/>
					<label htmlFor="link-checkbox-notification" className="ms-2 text-gray-400">
						Enable User Notification
					</label>
				</div>
			</form>
		</div>
	);
};

export default FormForCustormer;
